class Codon {
  constructor(aminoAcid, exon) {
    this.aminoAcid = aminoAcid;
    this.exon = exon;
    this.x0 = 0;
    this.x1 = 0;
    this.codonIndex = 0;
  }

  get size() {
    return Math.abs(this.x1 - this.x0);
  }

  get transcript() {
    return this.exon?.transcript;
  }

  setPosition(start, end, ind) {
    this.x0 = start;
    this.x1 = end;
    this.codonIndex = ind;
    return this;
  }
}

export default Codon;
